import { API } from '..';
import { StoreItem, getStoreItems } from '../payment/store.api';

// Admin cấp/thu hồi cosmetic (khung tên + khung avatar) cho user — MIỄN PHÍ.
// Backend: cab-payment-service, route admin qua gateway (Role Admin/Mod).
const BASE = '/v1/payment-service/admin/store';

export interface AdminInventoryItem {
  id: string;
  storeItemId: string;
  code: string;
  type: string;
  name: string;
  rarity?: string | null;
  style?: string | null;
  expiresAt?: string | null;
  quantity: number;
  isEquipped: boolean;
}

export interface AdminActionResult {
  success: boolean;
  message?: string | null;
}

export interface GrantCosmeticBody {
  userId: string;
  code: string;
  durationDays?: number | null; // null + permanent=false => theo hạn mặc định của món
  permanent: boolean;
  equip: boolean;
}

export interface CosmeticOwner {
  userId: string;
  userName?: string | null;
  fullName?: string | null;
  email?: string | null;
  itemCode: string;
  itemName: string;
  itemType: string; // Nametag | AvatarEffect
  rarity?: string | null;
  acquiredAt: string;
  expiresAt?: string | null;
  isEquipped: boolean;
}
export interface CosmeticOwnersResponse {
  total: number;
  pageNumber: number;
  pageSize: number;
  items: CosmeticOwner[];
}

// Danh sách tất cả user đang sở hữu cosmetic (bảng quản lý), phân trang + tìm tên/email.
export const getCosmeticOwners = (
  pageNumber = 1,
  pageSize = 20,
  keyword?: string
) =>
  API.get<CosmeticOwnersResponse>(`${BASE}/cosmetic-owners`, {
    params: { pageNumber, pageSize, keyword: keyword || undefined },
  }).then((r) => r.data);

export const getUserCosmeticInventory = (userId: string) =>
  API.get<AdminInventoryItem[]>(`${BASE}/user-inventory/${userId}`).then((r) => r.data);

export const grantCosmetic = (body: GrantCosmeticBody, totpCode: string) =>
  API.post<AdminActionResult>(`${BASE}/grant`, body, {
    params: { totpCode },
  }).then((r) => r.data);

export const revokeCosmetic = (
  body: { userId: string; code: string },
  totpCode: string
) =>
  API.post<AdminActionResult>(`${BASE}/revoke`, body, {
    params: { totpCode },
  }).then((r) => r.data);

// Danh mục item để chọn khi cấp (tái dùng store api).
export const getGrantableItems = (type: 'Nametag' | 'AvatarEffect'): Promise<StoreItem[]> =>
  getStoreItems(type).then((items) => items.filter((i) => i.type === type));
